import { Tag } from '@ps/isp-web-component-library';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Icon } from '@swf/sports/components';

import { TXTWCL_This_popular_accumulator_has_b_ELL } from './PopularAccumulatorCount.messages.json';
import styles from './PopularAccumulatorCount.scss';

const PopularAccumulatorCount = ({ count }: { count: number }) => {
  const { formatMessage } = useRegulatoryIntl();

  return (
    <div className={styles.flameIcon} data-testid="flame-counter">
      <Icon
        label={formatMessage(TXTWCL_This_popular_accumulator_has_b_ELL, { 0: count })}
        name="flame"
        size="x3"
      />
      <Tag className={styles.flameIconBadge}>{count}</Tag>
    </div>
  );
};

export default PopularAccumulatorCount;
